/* eslint-disable import/prefer-default-export */
export function convertApiTimestamp(date?: number) {
  if (!date) return undefined;

  return date * 1000;
}
